import { render } from "./DataCollection.vue?vue&type=template&id=1d6c2086"
import script from "./DataCollection.vue?vue&type=script&lang=js"
export * from "./DataCollection.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/rb-redev/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__